//オリジナルjquery
$(document).ready(function(){
  // ウィンドウの幅を取得
  var windowWidth = $(window).width();

  // 749px以下の場合の初期処理
  if (windowWidth <= 749) {
    // 初期表示時にbg-noneクラスを追加
    $('.header-wrapper, .header-background-blur, .bg-blur, .icon-close, .drawer__inner, .menu-drawer__navigation-container, .cart-count-bubble').addClass('bg-none');
    
    $(window).scroll(function(){
      if($(this).scrollTop() > 300) { // 300pxスクロールしたら条件を変更
        $('.header-wrapper, .header-background-blur, .bg-blur, .icon-close, .drawer__inner, .menu-drawer__navigation-container, .cart-count-bubble').removeClass('bg-none');
      } else {
        $('.header-wrapper, .header-background-blur, .bg-blur, .icon-close, .drawer__inner, .menu-drawer__navigation-container, .cart-count-bubble').addClass('bg-none');
      }
    });
  }
});